import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.authService.isAuthenticated()) {
      this.authService.logout();
      // Extrahiere den Sprachpräfix aus der URL (z.B. "en" aus "/en/admin")
      const segments = state.url.split('/');
      const langPrefix = segments[1] || 'en'; // Fallback auf 'en', falls nichts gefunden wird
      this.router.navigate([`/${langPrefix}/login`]);
      return false;
    }
    return true;
  }

}
